
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    margins: {
      type: Boolean,
      default: true,
    },
  },
}
